import { useCallback } from 'react';
import { listScenarios } from '../api/tumblerApi';
import useScopedLoad from './useScopedLoad';
export default function useScenarioList({ plant, factory, accessToken, page = 1 }) {
  const loader = useCallback((signal) => listScenarios({ plant, factory, page, accessToken, signal }), [plant, factory, page, accessToken]);
  const state = useScopedLoad(`${plant}/${factory}/${page}`, loader, Boolean(plant && factory && accessToken));
  return { ...state, results: state.data?.results || [], count: state.data?.count || 0, next: state.data?.next, previous: state.data?.previous };
}
